/*
 * File: d:\projects\AutoFiFront\src\Content\Filter\TextFilterHolder\FilterHolder.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday February 22nd 2023 1:44:32 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useRef, useState } from "react";
import styles from "Content/Filters/TextFilter/TextFilterHolder/TextFilterHolder.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import FilterSelector from "Content/Filters/TextFilter/TextFilterSelector/TextFilterSelector";
import CarService from "Services/Cars/CarService";
import { IsThisFilterTrue } from "Utils/UrlParams";

export type FilterHolderType = {
    id: string,
    filtersSelected?: (event: string[], reset: boolean) => void,
    curFilters?: string[],
    themeColor: string,
};

export function TextFilter(props: FilterHolderType) {
    const searchParams = new URLSearchParams(window.location.search);
    const myfilters = searchParams.has("filters") ? searchParams.get("filters")?.split(",") : [];
    const [catagoriesAvailable, setCatagoriesAvailable] = useState<string[]>(["catSelect"]);
    const [energiesAvailable, setEnergiesAvailable] = useState<string[]>(["energySelect"]);
    const [brandsAvailable, setBrandsAvailable] = useState<string[]>(["brandSelect"]);
    const [modelsAvailable, setModelsAvailable] = useState<string[]>(["modelSelect"]);
    const [catSelected, setCatSelected] = useState(IsThisFilterTrue(1, myfilters!));
    const [carCat, setCarCat] = useState("catSelect");
    const [energySelected, setEnergySelected] = useState(IsThisFilterTrue(2, myfilters!));
    const [carEnergy, setCarEnergy] = useState("energySelect");
    const [brandSelected, setBrandSelected] = useState(IsThisFilterTrue(3, myfilters!));
    const [carBrand, setCarBrand] = useState("brandSelect");
    const [modelSelected, setModelSelected] = useState(IsThisFilterTrue(4, myfilters!));
    const [carModel, setCarModel] = useState("modelSelect");
    const firstLoad = useRef(true);

    useEffect(() => {
        var myRet = CarService.getCarCategoriesAvailable();
        myRet.then(x => {x.unshift("catSelect"); setCatagoriesAvailable(x)});
        if (props.curFilters !== undefined && props.curFilters.length > 0) {
            for (let i = 0; i <props.curFilters.length; ++i){
                switch (i) {
                    case 0 :
                        setCarCat(props.curFilters[0]);
                        var myRet = CarService.getCarEnergiesAvailable(props.curFilters);
                        myRet.then(x => {x.unshift("energySelect"); setEnergiesAvailable(x)});
                        setCatSelected(true);
                        break;
                    case 1 :
                        var myRet = CarService.getCarBrandsAvailable(props.curFilters);
                        myRet.then(x => {x.unshift("brandSelect"); setBrandsAvailable(x)});
                        setCarEnergy(props.curFilters[1]);
                        setEnergySelected(true);
                        break;
                    case 2 :
                        var myRet = CarService.getCarModelsAvailable(props.curFilters);
                        myRet.then(x => {x.unshift("modelSelect"); setModelsAvailable(x)});
                        setCarBrand(props.curFilters[2]);
                        setBrandSelected(true);
                        break;
                    case 3 :
                        setCarModel(props.curFilters[3]);
                        setModelSelected(true);
                        break;
                    default:
                        break;
                }
            }
        } else {
            setCarCat("catSelect");
            setCarEnergy("energySelect");
            setCarBrand("brandSelect");
            setCarModel("modelSelect");
            setCatSelected(false);
            setEnergySelected(false);
            setBrandSelected(false);
            setModelSelected(false);
        }
    }, [props.curFilters]);

    useEffect(()=> {
        if (firstLoad.current) {
            func(false);
            firstLoad.current = false;
        } else
            func(catSelected);
    },[carCat, carEnergy, carBrand, carModel]);

    const func = (item: boolean) =>{
        const myFilters: string[] = [];
        if (carCat !== "catSelect" && carCat !== "" )
            myFilters.push(carCat);

        if (carEnergy !== "energySelect" && carEnergy !== "" )
            myFilters.push(carEnergy);

        if (carBrand !== "brandSelect" && carBrand !== "" )
            myFilters.push(carBrand);

        if (carModel !== "modelSelect" && carModel !== "" )
            myFilters.push(carModel);

        if (props.filtersSelected != undefined)
            props.filtersSelected(myFilters, item);
        if (item) {
            var myRet = CarService.getCarCategoriesAvailable();
            myRet.then(x => setCatagoriesAvailable(x));
            if (myFilters.length >= 1){
                var myRet = CarService.getCarEnergiesAvailable(myFilters);
                myRet.then(x => setEnergiesAvailable(x));
            }
            if (myFilters.length >= 2){
                var myRet = CarService.getCarBrandsAvailable(myFilters);
                myRet.then(x => setBrandsAvailable(x));
            }
            if (myFilters.length >= 3){
                var myRet = CarService.getCarModelsAvailable(myFilters);
                myRet.then(x => setModelsAvailable(x));
            }
        }
    };

    const catSelection = (cat: React.ChangeEvent<HTMLSelectElement>) => {
        setCarCat(cat.target.value);
        setCatSelected(true);
    };
    const catSelectionReset = () => {
        setCarCat("catSelect");
        setCatSelected(false);
    };
    const energySelection = (energy: React.ChangeEvent<HTMLSelectElement>) => {
        setCarEnergy(energy.target.value);
        setEnergySelected(true);
    };
    const energySelectionReset = () => {
        setCarEnergy("energySelect");
        setEnergySelected(false);
    };
    const brandSelection = (brand: React.ChangeEvent<HTMLSelectElement>) => {
        setCarBrand(brand.target.value);
        setBrandSelected(true);
    };
    const brandSelectionReset = () => {
        setCarBrand("brandSelect");
        setBrandSelected(false);
    };
    const modelSelection = (brand: React.ChangeEvent<HTMLSelectElement>) => {
        setCarModel(brand.target.value);
        setModelSelected(true);
    };
    const modelSelectionReset = () => {
        setCarModel("modelSelect");
        setModelSelected(false);
    };

    return (
        <React.Fragment>
            <div id={props.id} className={`${styles.filter}`}>
                <FilterSelector
                    selected={catSelected}
                    selectedValue={translator.decode(`carType.${carCat.toLowerCase()}`)!}
                    selectData={catagoriesAvailable.map((x) => { return { value: x, label: translator.decode(`carType.${x.toLowerCase()}`)! }; })}
                    functionReset={catSelectionReset}
                    functionSet={catSelection}
                    themeColor={props.themeColor}
                    asFollower={energySelected}/>

                { catSelected ? <FilterSelector
                                    selected={energySelected}
                                    selectedValue={translator.decode(`energyType.${carEnergy.toLowerCase()}`)!}
                                    selectData={energiesAvailable.map((x) => { return { value: x, label: translator.decode(`energyType.${x.toLowerCase()}`)! }; })}
                                    functionReset={energySelectionReset}
                                    functionSet={energySelection}
                                    themeColor={props.themeColor}
                                    asFollower={brandSelected}/>
                                    :null
                                }

                { energySelected ? <FilterSelector
                                    selected={brandSelected}
                                    selectedValue={carBrand}
                                    selectData={brandsAvailable.map((x) => { return { value: x, label: x != "brandSelect" ? x : translator.decode(`brand.${x.toLowerCase()}`)!}})}
                                    functionReset={brandSelectionReset}
                                    functionSet={brandSelection}
                                    themeColor={props.themeColor}
                                    asFollower={modelSelected}/>
                                    :null
                                }

                { brandSelected ? <FilterSelector
                                    selected={modelSelected}
                                    selectedValue={carModel}
                                    selectData={modelsAvailable.map((x) => { return { value: x, label: x != "modelSelect" ? x : translator.decode(`model.${x.toLowerCase()}`)! }})}
                                    functionReset={modelSelectionReset}
                                    functionSet={modelSelection}
                                    themeColor={props.themeColor}
                                    asFollower={false}/>
                                    :null
                                }
            </div>
        </React.Fragment>
    )
}
